export const breakpoints = {
  extraSmall: '(min-width: 0px)',
  small: '(min-width: 550px)',
  medium: '(min-width: 736px)',
  large: '(min-width: 992px)',
  extraLarge: '(min-width: 1264px)',
};
